import React from "react";

import { Divider } from "./styles";

function CardDivider() {
  return <Divider />;
}

export default CardDivider;
